module.exports = __webpack_public_path__ + "static/Booksy-7bddfe77760090adb25c434a74bf8a19.svg";